import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/next/footer';
import Header from '../components/next/header';
import HomePage from '../pages/next/home_page';
import ContactPage from '../pages/next/contact_page';

export default function NextTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                contactPage={ContactPage}
            />
            <Footer />
        </React.Fragment>
    )
}
